/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Ocop_Cert_TitleInputs */

const vi_shop_ocop_cert_title = /** @type {(inputs: Shop_Ocop_Cert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên hiển thị của chứng nhận`)
};

/**

* @param {Shop_Ocop_Cert_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_ocop_cert_title = /** @type {((inputs?: Shop_Ocop_Cert_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Ocop_Cert_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_ocop_cert_title(inputs)
});